import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-dark border-y border-border-dark/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="text-primary-light text-sm font-bold uppercase tracking-[0.2em]">{t.how.kicker}</span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white font-heading">
            {t.how.title}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-pink">
              {t.how.titleGrad}
            </span>
          </h2>
          <p className="mt-5 text-lg text-slate-400 leading-relaxed">{t.how.intro}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {t.how.blocks.map((block, index) => (
            <div
              key={block.title}
              className="bg-card-dark border border-border-dark rounded-2xl p-8 hover:border-primary/30 transition-all duration-300 group relative overflow-hidden"
            >
              <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full bg-primary/5 group-hover:bg-primary/10 transition-colors" />
              <div className="relative">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center mb-5 shadow-glow text-white font-extrabold text-lg font-heading">
                  {index + 1}
                </div>
                <h3 className="text-xl font-bold text-white mb-3 font-heading">{block.title}</h3>
                <p className="text-slate-400 leading-relaxed mb-5">{block.description}</p>
                <ul className="space-y-2">
                  {block.points.map((point) => (
                    <li key={point} className="flex items-center gap-2 text-sm text-slate-300">
                      <CheckCircle className="w-4 h-4 text-primary-light shrink-0" />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
